import React from 'react';
import cx from 'classnames';

import styles from './Flags.module.scss';

export interface Props {
  className?: Parameters<typeof cx>[0];
}

export const GB: React.FC<Props> = ({ className }) => (
  <i className={cx(styles.icon, className)}>
    <svg width={25} height={24} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path d='M24.5 4H.5v15.998h24V4z' fill='#fff' />
        <path
          d='M14 4h-3v6.502H.5v3H11v6.496h3v-6.496h10.5v-3H14V4z'
          fill='#D80027'
        />
        <path
          d='m18.96 14.781l5.54 3.08v-3.08h-5.54zm-3.849 0l9.39 5.217v-1.471l-6.737-3.746h-2.653zm6.886 5.217l-6.886-3.825v3.825h6.886z'
          fill='#0052B4'
        />
        <path
          d='m15.111 14.781l9.39 5.217v-1.471l-6.737-3.746h-2.653z'
          fill='#fff'
        />
        <path
          d='m15.111 14.781l9.39 5.217v-1.471l-6.737-3.746h-2.653z'
          fill='#D80027'
        />
        <path
          d='M4.733 14.781L.5 17.134v-2.353h4.233zM9.89 15.447v4.551H1.694l8.194-4.551z'
          fill='#0052B4'
        />
        <path
          d='M7.236 14.781L.5 18.527v1.471l9.39-5.217H7.235z'
          fill='#D80027'
        />
        <path
          d='M6.04 9.217L.5 6.137v3.08h5.54zM9.89 9.217L.5 4v1.477l6.736 3.74h2.653zM3.003 4L9.89 7.83V4H3.003z'
          fill='#0052B4'
        />
        <path d='M9.89 9.217L.5 4v1.477l6.736 3.74h2.653z' fill='#fff' />
        <path d='M9.89 9.217L.5 4v1.477l6.736 3.74h2.653z' fill='#D80027' />
        <path
          d='M20.267 9.217L24.5 6.864v2.353h-4.233zM15.111 8.556V4h8.194L15.11 8.556z'
          fill='#0052B4'
        />
        <path
          d='M17.764 9.217l6.736-3.74V4l-9.389 5.217h2.653z'
          fill='#D80027'
        />
      </g>
      <path d='M.5 4h24v15.998H.5z' stroke='#111' />
    </svg>
  </i>
);

GB.displayName = 'GB';
export default GB;
